var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconProfileCommunity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-311 -382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M319.25 389.7C319.25 390.943 318.243 391.95 317 391.95 315.757 391.95 314.75 390.943 314.75 389.7 314.75 388.457 315.757 387.45 317 387.45 318.243 387.45 319.25 388.457 319.25 389.7Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.25 389.7C331.25 390.943 330.243 391.95 329 391.95 327.757 391.95 326.75 390.943 326.75 389.7 326.75 388.457 327.757 387.45 329 387.45 330.243 387.45 331.25 388.457 331.25 389.7Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.5 400.55 327.5 398.3C327.5 397.95 327.35 397.6 327.05 397.4 326.45 396.9 325.65 396.55 324.85 396.35 324.3 396.2 323.65 396.05 323 396.05 322.4 396.05 321.75 396.15 321.15 396.35 320.35 396.55 319.6 396.95 318.95 397.4 318.65 397.65 318.5 397.95 318.5 398.3L318.5 400.55 327.5 400.55Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.25 393.2C325.25 394.443 324.243 395.45 323 395.45 321.757 395.45 320.75 394.443 320.75 393.2 320.75 391.957 321.757 390.95 323 390.95 324.243 390.95 325.25 391.957 325.25 393.2Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.05 393.9C332.45 393.4 331.65 393.05 330.85 392.85 330.3 392.7 329.65 392.55 329 392.55 328.4 392.55 327.75 392.65 327.15 392.85 326.85 392.95 326.55 393.05 326.25 393.2L326.25 393.25C326.25 394.1 325.9 394.9 325.35 395.45 326.3 395.75 327.05 396.15 327.65 396.6 327.8 396.75 327.95 396.85 328.05 397.05L333.5 397.05 333.5 394.8C333.5 394.45 333.35 394.1 333.05 393.9Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.35 396.6 318.35 396.6C319.05 396.1 319.85 395.7 320.65 395.45 320.1 394.85 319.75 394.1 319.75 393.25 319.75 393.2 319.75 393.2 319.75 393.15 319.45 393.05 319.15 392.9 318.85 392.85 318.3 392.7 317.65 392.55 317 392.55 316.4 392.55 315.75 392.65 315.15 392.85 314.35 393.1 313.6 393.45 312.95 393.9 312.65 394.1 312.5 394.45 312.5 394.8L312.5 397.05 317.9 397.05C318.05 396.85 318.15 396.75 318.35 396.6Z",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfileCommunity);
export default __webpack_public_path__ + "static/media/icon-profile-community.3170a5917ebe7a0b08c193d696bd54d1.svg";
export { ForwardRef as ReactComponent };